import { gql, type TypedDocumentNode } from "@apollo/client";
import { type GQL } from "@binale-tech/shared";

export const contactSave: TypedDocumentNode<Pick<GQL.IMutation, "contactSave">, GQL.IMutationContactSaveArgs> = gql`
    mutation contactSave($input: ContactUpdateInput!) {
        contactSave(input: $input)
    }
`;

export const contactDelete: TypedDocumentNode<
    Pick<GQL.IMutation, "contactDelete">,
    GQL.IMutationContactDeleteArgs
> = gql`
    mutation contactDelete($input: IDCompanyIDInput!) {
        contactDelete(input: $input)
    }
`;

export const contactSearch: TypedDocumentNode<
    Pick<GQL.IMutation, "contactSearch">,
    GQL.IMutationContactSearchArgs
> = gql`
    mutation contactSearch($term: String!, $companyId: ID!) {
        contactSearch(term: $term, companyId: $companyId) {
            contacts
        }
    }
`;
